var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 80,
    viewBox: "0 45 320 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4931,
    cy: 118.184,
    r: 20.1884,
    transform: "rotate(-79.0728 98.4931 118.184)",
    fill: "#ECCA49"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3212,
    cy: 46.0178,
    r: 20.1884,
    transform: "rotate(-79.0728 35.3212 46.0178)",
    fill: "#E1B042"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.159,
    cy: 21.9499,
    r: 20.1884,
    transform: "rotate(-79.0728 230.159 21.9499)",
    fill: "#E3A04A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.983,
    cy: 70.2297,
    r: 20.1884,
    transform: "rotate(-79.0728 213.983 70.2297)",
    fill: "#ED6762"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.296,
    cy: 126.279,
    r: 20.1884,
    transform: "rotate(-79.0728 220.296 126.279)",
    fill: "#ED6762"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.698,
    cy: 67.8576,
    r: 20.1884,
    transform: "rotate(-79.0728 272.698 67.8576)",
    fill: "#D44841"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.706,
    cy: 123.269,
    r: 20.1884,
    transform: "rotate(-79.0728 275.706 123.269)",
    fill: "#D44841"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2216,
    cy: 67.091,
    r: 20.1884,
    transform: "rotate(-79.0728 91.2216 67.091)",
    fill: "#3882C7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.138,
    cy: 91.7859,
    r: 20.1884,
    transform: "rotate(-79.0728 148.138 91.7859)",
    fill: "#164B8A"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.048,
    cy: 5.34885,
    r: 20.1884,
    transform: "rotate(-79.0728 295.048 5.34885)",
    fill: "#F3A374"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.255,
    cy: 40.8405,
    r: 20.1884,
    transform: "rotate(-79.0728 168.255 40.8405)",
    fill: "#D67742"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.481,
    cy: 6.49485,
    r: 20.1884,
    transform: "rotate(-79.0728 123.481 6.49485)",
    fill: "#EF8481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots2);
export default __webpack_public_path__ + "static/media/dots_2.618f939c13da384e2bd1e2055d106522.svg";
export { ForwardRef as ReactComponent };